var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceRjr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "45mm",
    height: "45mm",
    viewBox: "0 0 127.5591 127.5591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ac,.ad,.ah,.ai,.aj,.ak,.al,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.x,.y{fill:none;}.b{fill:#ffdb06;}.c{fill:#00e1ff;}.d,.e,.f,.y{stroke:#ff9376;}.aj,.ak,.al,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{stroke-linecap:round;}.d,.e,.f{stroke-linejoin:round;}.aj,.ak,.al,.d,.p{stroke-width:2px;}.e{stroke-width:1.5px;}.f{stroke-width:0.5px;}.ai,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{stroke:#ffdb06;}.ad,.ag,.ai,.aj,.ak,.al,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.y{stroke-miterlimit:10;}.g{stroke-width:0.6px;}.h{stroke-width:0.8px;}.i{stroke-width:1.2px;}.j{stroke-width:1.4px;}.k{stroke-width:1.6px;}.l{stroke-width:1.8px;}.n{stroke-width:2.4px;}.o{stroke-width:2.2px;}.q{stroke-width:2.6px;}.r{stroke-width:3px;}.s{stroke-width:2.8px;}.t{clip-path:url(#a);}.u{clip-path:url(#b);}.v{fill:#db004f;}.w{opacity:0.7;fill:url(#c);}.al,.x{stroke:#7a0032;}.ac,.ah,.x{stroke-width:12px;}.ad,.ai,.y{stroke-width:8px;}.z{clip-path:url(#d);}.aa{fill:#0059c4;}.ab{opacity:0.5;fill:url(#e);}.ac{stroke:#001959;}.ad{stroke:#00e1ff;}.ae{clip-path:url(#f);}.af{fill:#ff7300;}.ag{opacity:0.8;fill:url(#g);stroke:url(#h);}.ah,.aj{stroke:#992f20;}.ak{stroke:#004743;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 63.7795,
    cy: 63.7795,
    r: 63.7698
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M120.0189,96.6288S103.6112,129.06,63.6548,129.1707c-39.6924.11-56.3642-32.5419-56.3642-32.5419L63.6548,64.0869Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-400.8241 273.0268)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 105.943 5.139 110.462 9.29 113.662 7.876 105.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "46.762 115.651 48.598 105.955 53.018 112.638"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 97.295 77.498 96.202 74.936 105.048 82.82 102.982 75.95 114.903"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 108.771 101.999 115.644 104.277 107.454"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 112.5773,
    y1: 64.3425,
    x2: 107.744,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.556 90.138 112.577 93.056 106.567 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "5.883 20.287 8.111 11.307 13.58 16.116"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "27.441 16.866 22.464 16.608 22.319 19.409 17.341 19.151 17.196 21.952 13.15 18.934 11.913 22.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "6.139 82.134 10.379 84.753 11.853 82.367 16.093 84.986 17.567 82.6 19.664 87.192 22.699 84.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 41.7356,
    y1: 10.0519,
    x2: 43.8812,
    y2: 5.415
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 77.4353,
    y1: 49.6401,
    x2: 79.5808,
    y2: 45.0032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 21.1106,
    y1: 12.6193,
    x2: 20.2272,
    y2: 9.5092
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 28.6978,
    y1: 13.192,
    x2: 27.4142,
    y2: 10.4276
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 62.4688,
    y1: 55.7816,
    x2: 65.016,
    y2: 54.1078
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "36.803 10.947 35.357 16.064 42.7 13.505"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "31.819 20.752 32.124 24.388 26.745 23.021 31.819 20.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "8.876 29.307 8.876 31.866 11.546 31.866 10.211 35.76 14.419 36.428"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "75.475 40.52 77.867 41.428 78.814 38.931 81.982 41.56 84.098 37.863"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 22.1052,
    y1: 32.5893,
    x2: 15.43,
    y2: 26.5816
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 27.8423,
    y1: 84.0098,
    x2: 24.2697,
    y2: 75.7705
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 23.1165,
    y1: 28.8623,
    x2: 31.0155,
    y2: 30.3086
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "38.779 19.973 44.12 19.083 42.451 22.421 48.904 21.387"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "37.444 24.638 37.426 29.578 40.949 28.213 42.548 33.5 48.33 28.86 48.835 32.665"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "54.28 56.54 55.397 61.352 58.512 59.215 61.282 63.994 65.844 58.151 67.209 61.739"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "28.902 34.994 37.357 38.906 22.242 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "18.169 39.631 11.647 41.158 19.677 47.322"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.2903,
    y1: 46.5125,
    x2: 6.1619,
    y2: 45.2984
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 35.4578,
    y1: 79.8603,
    x2: 31.3294,
    y2: 78.6462
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "12.226 51.959 18.419 51.076 16.082 55.069 23.677 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.523 45.298 30.459 47.322 27.066 48.905 32.017 50.432 30.409 55.831 33.762 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "51.378 8.732 60.343 7.137 58.362 13.053 64.124 13.053 63.427 17.447 72.751 16.435"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 50.4965,
    y1: 13.0643,
    x2: 52.0179,
    y2: 17.9735
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 52.1109,
    y1: 23.4041,
    x2: 62.9502,
    y2: 21.7365
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "55.926 27.22 55.926 37.997 62.194 31.611"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 44.6997,
    y1: 39.6312,
    x2: 50.4965,
    y2: 36.5211
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 37.3569,
    y1: 43.4764,
    x2: 40.7502,
    y2: 47.3217
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "47.427 48.905 46.632 44.268 53.16 45.905 53.16 42.465 61.336 43.476 61.336 39.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "65.588 27.972 72.412 29.307 66.725 33.98 76.203 34.994"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 69.9478,
    y1: 24.1371,
    x2: 70.7506,
    y2: 20.1845
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "73.138 9.002 68.971 7.456 73.032 4.015 73.138 9.002"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "10.29 61.232 10.29 67.453 14.419 65.869 10.29 61.232"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: 61.2324,
    x2: 28.056,
    y2: 62.8158
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "23.767 66.23 17.934 68.355 19.448 74.586 10.83 74.245"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 7.2261,
    y1: 71.2375,
    x2: 5.1619,
    y2: 76.2533
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.8245,
    y1: 64.3425,
    x2: 0.9913,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "28.048 73.057 30.8 68.431 32.994 74.225 34.782 63.811 38.358 68.463 38.377 63.826 43.832 63.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "41.028 58.179 42.808 52.674 50.497 62.816"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "50.16 53.945 50.984 50.542 56.901 50.836"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 58.9014,
    y1: 47.905,
    x2: 64.588,
    y2: 49.9469
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "69.474 40.508 70.349 51.076 73.549 50.432 69.474 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "79.357 32.608 83.217 30.309 76.203 25.721 80.786 23.133 75.066 19.151"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 79.1413,
    y1: 15.6912,
    x2: 84.3541,
    y2: 14.8633
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "80.786 7.009 75.066 13.444 88.829 7.009"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "44.747 68.325 41.057 76.105 52.468 66.074"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "54.95 71.09 52.468 78.253 61.336 79.86 54.95 71.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 61.3359,
    y1: 68.0896,
    x2: 68.1287,
    y2: 68.0896
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "44.7 79.86 42.808 91.232 37.357 83.325"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "33.394 86.663 32.124 93.491 26.745 91.985 25.27 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 22.6689,
    y1: 92.9013,
    x2: 17.43,
    y2: 97.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "7.72 101.284 10.513 90.709 16.097 107.439"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 105.399 5.139 109.917 9.29 113.118 7.876 105.399"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 -0.81 5.139 3.709 9.29 6.909 7.876 -0.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: 101.3989,
    x2: 19.677,
    y2: 106.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.27 103.093 28.842 106.671 30.409 103.093 34.937 106.671 35.688 97.445 43.842 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 41.0283,
    y1: 96.1273,
    x2: 46.6325,
    y2: 99.1396
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "48.26 83.136 49.113 89.192 54.761 84.134 53.16 94.056 59.089 90.103 61.336 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 48.2598,
    y1: 94.0563,
    x2: 50.4965,
    y2: 101.3989
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "56.916 100.14 54.16 107.671 57.531 107.671 56.916 100.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "83.217 19.151 90.646 20.185 86.931 10.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "92.981 7.009 91.474 11.432 97.837 14.863 94.656 23.967 99.708 24.388 98.817 32.589"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "102.7 19.799 105.524 11.432 108.16 22.161 102.7 19.799"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 95.8374,
    y1: 9.006,
    x2: 98.6998,
    y2: 7.1729
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "103.43 27.22 107.854 29.585 100.7 37.751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 88.8292,
    y1: 27.2196,
    x2: 84.3541,
    y2: 23.9671
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 93.5454,
    y1: 26.5816,
    x2: 90.6456,
    y2: 34.9943
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "88.829 46.512 86.592 34.994 97.123 51.076"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "92.21 37.751 96.318 37.751 96.318 41.56 102.582 43.035 100.7 47.322 107.007 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 107.0069,
    y1: 37.7511,
    x2: 106.1596,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "83.217 47.322 81.947 51.883 90.646 49.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "70.091 55.519 76.596 54.572 75.599 61.569 81.693 59.882 81.439 64.812 88.514 65.355"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 84.0978,
    y1: 56.5955,
    x2: 90.6456,
    y2: 56.5955
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "93.545 53.836 97.123 63.267 88.829 61.437"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "98.472 56.248 102.814 51.599 107.257 56.852 98.472 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "102.582 62.024 106.583 67.631 98.139 69.204 102.361 73.237 90.646 76.77 93.545 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "97.837 80.89 103.43 78.646 106.16 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 107.0069,
    y1: 73.2375,
    x2: 107.8541,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.549 66.016 79.786 67.334 70.349 73.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "65.588 72.475 64.742 76.253 70.349 76.86 65.588 82.01 75.066 82.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 59.9014,
    y1: 85.0098,
    x2: 67.1045,
    y2: 89.192
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "66.861 93.618 75.668 87.794 67.988 104.404"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 64.7424,
    y1: 99.3989,
    x2: 61.3359,
    y2: 104.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 115.955 48.598 106.258 53.018 112.942"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "46.762 8.898 48.598 -0.798 53.018 5.885"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "77.469 74.77 86.931 70.028 78.508 79.819"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 92.9759,
    y1: 71.0896,
    x2: 92.21,
    y2: 66.9936
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 82.2167,
    y1: 79.8186,
    x2: 87.8292,
    y2: 78.8914
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "78.508 84.663 86.297 83.546 84.098 92.056 78.508 84.663"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 -9.458 77.498 -10.55 74.936 -1.705 82.82 -3.77 75.95 8.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 97.707 77.498 96.614 74.936 105.46 82.82 103.394 75.95 115.315"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "84.354 99.14 86.931 96.99 91.474 102.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "90.646 94.056 90.646 89.192 96.016 91.624 98.614 84.134 101.999 86.663 101.999 84.134"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 90.138 112.721 93.056 106.71 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-6.196 90.138 5.825 93.056 -0.186 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "93.545 97.931 98.614 95.173 98.139 102.905 106.16 102.058 104.277 105.258 110.515 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 104.2769,
    y1: 96.4452,
    x2: 109.3603,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.5917,
    y1: 106.2585,
    x2: 98.1395,
    y2: 107.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 2.019 101.999 8.891 104.277 0.701"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "12.354 1.848 16.542 9.289 18.768 3.919"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "23.873 6.711 24.914 0.994 27.184 7.914 32.299 3.376 32.299 9.793 40.408 2.348"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 7.194,
    y1: 24.3885,
    x2: 3.4079,
    y2: 27.9723
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 5.1388,
    y1: 34.9943,
    x2: 6.1619,
    y2: 41.0096
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.162 50.926 6.65 56.243 4.408 52.076"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "-4.053 19.799 -1.229 11.432 1.407 22.161 -4.053 19.799"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-3.323 27.22 1.101 29.585 -6.053 37.751"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-14.543 37.751 -10.435 37.751 -10.435 41.56 -4.17 43.035 -6.053 47.322 0.254 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.2541,
    y1: 37.7511,
    x2: -0.5931,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "-8.281 56.248 -3.939 51.599 0.504 56.852 -8.281 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-4.17 62.024 -0.169 67.631 -8.613 69.204 -4.391 73.237 -16.107 76.77 -13.207 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-8.915 80.89 -3.323 78.646 -0.593 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.2541,
    y1: 73.2375,
    x2: 1.1013,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-6.053 90.138 5.968 93.056 -0.043 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-13.207 97.931 -8.138 95.173 -8.613 102.905 -0.593 102.058 -2.476 105.258 3.763 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: -2.4758,
    y1: 96.4452,
    x2: 2.6075,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "7.72 -5.468 10.513 -16.044 16.097 0.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 -1.354 5.139 3.165 9.29 6.365 7.876 -1.354"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: -5.3539,
    x2: 19.677,
    y2: -0.0822
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.27 -3.659 28.842 -0.082 30.409 -3.659 34.937 -0.082 35.688 -9.308 43.842 -0.082"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "56.916 -6.613 54.16 0.918 57.531 0.918 56.916 -6.613"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 9.202 48.598 -0.494 53.018 6.189"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 -9.046 77.498 -10.138 74.936 -1.293 82.82 -3.358 75.95 8.562"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "93.545 -8.822 98.614 -11.58 98.139 -3.848 106.16 -4.695 104.277 -1.494 110.515 -0.082"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.5917,
    y1: -0.4943,
    x2: 98.1395,
    y2: 0.9178
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-13.207 -8.822 -8.138 -11.58 -8.613 -3.848 -0.593 -4.695 -2.476 -1.494 3.763 -0.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.2906,96.629s-19.8821-30.4249,0-65.0838C27.0412-2.8845,63.6548-.9967,63.6548-.9967V64.0871Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-338.0268 272.8231)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.4954,108.4a.3837.3837,0,0,1-.1592-.0352,5.7,5.7,0,1,1,4.832-10.3261.3752.3752,0,1,1-.3183.68,4.95,4.95,0,1,0-4.1953,8.9668.3751.3751,0,0,1-.1592.7149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.1661,111.1162a.2464.2464,0,0,1-.0937-.0186.2491.2491,0,0,1-.1377-.3252l3.3242-8.2431a.25.25,0,1,1,.4629.1875l-3.3242,8.2431A.2505.2505,0,0,1,106.1661,111.1162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.388,13.6963a.5.5,0,0,1-.4346-.7471A4.67,4.67,0,1,0,7.8382,8.3261.5.5,0,1,1,6.969,7.83a5.67,5.67,0,0,1,9.8535,5.6133A.5.5,0,0,1,16.388,13.6963Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.7684,12.3843a.3394.3394,0,0,0,.4765-.1436A3.6826,3.6826,0,0,0,8.8762,8.6122a.3394.3394,0,0,0,.1194.4831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M31.2073,49.7951a.3452.3452,0,0,0-.3786.322,6.3129,6.3129,0,0,0,12.5468,1.2165.3452.3452,0,0,0-.31-.3887Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M108.5536,70.16a.3431.3431,0,0,0,.4425-.2275,4.8991,4.8991,0,0,0-9.244-3.1685.343.343,0,0,0,.21.4511Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M39.08,102.561a.3453.3453,0,0,0-.3787.322,6.3129,6.3129,0,0,0,12.5468,1.2164.3452.3452,0,0,0-.31-.3887Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M65.8326,20.1108a.3437.3437,0,0,0-.4682.1694,5.0847,5.0847,0,0,0,9.1007,4.4809.3438.3438,0,0,0-.1513-.4744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M54.3928,36.1562a.5006.5006,0,0,1-.4794-.6406,5.8431,5.8431,0,0,0-11.2129-3.292.5.5,0,1,1-.959-.2812,6.8424,6.8424,0,0,1,13.1308,3.8544A.4994.4994,0,0,1,54.3928,36.1562Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.3182,35.237a.3224.3224,0,0,0,.4061-.2324,4.518,4.518,0,0,0-8.6457-2.5386.3224.3224,0,0,0,.216.4151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.1389,23.3134a7.0973,7.0973,0,0,1-6.9345-5.6875l.98-.1972a6.0909,6.0909,0,0,0,11.9395-2.418l.98-.1992a7.1,7.1,0,0,1-5.543,8.3584A7.1843,7.1843,0,0,1,43.1389,23.3134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.9068,16.8583a.342.342,0,0,0-.2662.42A4.6949,4.6949,0,0,0,47.8168,15.42a.3421.3421,0,0,0-.4086-.2831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.71,48.1093a.3748.3748,0,0,1-.3535-.2509,6.1356,6.1356,0,1,1,11.5762-4.0713.3746.3746,0,1,1-.707.248A5.3864,5.3864,0,0,0,13.0637,47.61a.3753.3753,0,0,1-.3535.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.5675,44.484a.3389.3389,0,0,0,.2042-.4513,4.1037,4.1037,0,0,0-7.7137,2.71.3423.3423,0,0,0,.445.2263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.4954,108.2256a.3853.3853,0,0,1-.1592-.0352,5.7,5.7,0,1,1,4.832-10.3252.3753.3753,0,1,1-.3183.68,4.9494,4.9494,0,1,0-4.1953,8.9658.3751.3751,0,0,1-.1592.7149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.7363,99.1787a.34.34,0,0,0-.1812-.4639,3.7931,3.7931,0,0,0-3.201,6.84.34.34,0,0,0,.4723-.1581Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.4954,1.6474a.3851.3851,0,0,1-.1592-.0351,5.7076,5.7076,0,0,1-2.7471-7.5791,5.7072,5.7072,0,0,1,7.5791-2.7471.3755.3755,0,0,1,.1807.499.376.376,0,0,1-.499.1807,4.9569,4.9569,0,0,0-6.5811,2.3857A4.9549,4.9549,0,0,0,30.6546.9326a.3751.3751,0,0,1-.1592.7148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.637,55.8613a.37.37,0,0,1-.1162-.0186.3747.3747,0,0,1-.24-.4726A4.1184,4.1184,0,0,0,22.65,50.1816a4.1131,4.1131,0,0,0-5.1885,2.63.3749.3749,0,0,1-.7129-.2324,4.8635,4.8635,0,0,1,9.2451,3.0234A.375.375,0,0,1,25.637,55.8613Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.8927,54.81a.3352.3352,0,0,0,.4353-.2363,3.1972,3.1972,0,0,0-6.0389-1.9752.3353.3353,0,0,0,.2115.4479Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M98.9124,20.6152a7.2811,7.2811,0,0,1-7.18-6.1992.3757.3757,0,0,1,.3154-.4268.3682.3682,0,0,1,.4268.3155A6.5262,6.5262,0,0,0,105.3831,12.37a.3757.3757,0,0,1,.3154-.4268.37.37,0,0,1,.4268.3155,7.2772,7.2772,0,0,1-6.1182,8.2744A7.4036,7.4036,0,0,1,98.9124,20.6152Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M95.1964,13.7467a.3431.3431,0,0,0-.2879.4058,4.9156,4.9156,0,0,0,9.6967-1.4532.3431.3431,0,0,0-.3942-.3036Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.8186,28.2539a.4987.4987,0,0,1-.3769-.1719A5.6693,5.6693,0,1,1,20,20.6445a.5.5,0,0,1-.7539.6563,4.67,4.67,0,0,0-7.0508,6.125.5.5,0,0,1-.377.8281Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.0019,23.5344a.3393.3393,0,0,0,.2415-.4351,3.6826,3.6826,0,0,0-7.0958,1.8369.3394.3394,0,0,0,.4224.2632Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.3333,16.8623a6.2378,6.2378,0,0,1-2.708-.6192.5.5,0,0,1,.4336-.9,5.2724,5.2724,0,0,0,4.5683-9.5039.5.5,0,1,1,.4336-.9,6.2719,6.2719,0,0,1-2.7275,11.9239Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.1,12.8758a.3421.3421,0,0,0-.05.4966,4.1114,4.1114,0,0,0,6.4677-5.0261.3423.3423,0,0,0-.4938-.0736Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.1731,93.47a8.9142,8.9142,0,0,1-2.6621-.4082.5.5,0,0,1,.2988-.9551,7.931,7.931,0,1,0,4.7383-15.1377.5.5,0,0,1,.2988-.9551A8.9319,8.9319,0,0,1,10.1731,93.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.6011,87.9519a.3641.3641,0,0,0-.03.5245,6.0057,6.0057,0,0,0,9.0947-7.8094.3643.3643,0,0,0-.5232-.0491Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.763,19.7568a.376.376,0,0,1-.3047-.1562,4.281,4.281,0,1,1,6.9531-4.9961.3751.3751,0,0,1-.6094.4375,3.5308,3.5308,0,1,0-5.7344,4.1211.3749.3749,0,0,1-.3046.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.5055,15.1847a.3472.3472,0,0,0-.2723-.4544,2.5993,2.5993,0,0,0-1.7266,4.8346.3472.3472,0,0,0,.4985-.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.1868,30.4277c-.0332,0-.0674-.001-.1006-.001a3.9981,3.9981,0,0,1-2.8154-1.248.3751.3751,0,1,1,.5429-.5176,3.253,3.253,0,0,0,2.2911,1.0156,3.0907,3.0907,0,0,0,2.3369-.9023,3.2747,3.2747,0,0,0,.1133-4.6279.3751.3751,0,1,1,.5429-.5176,4.0239,4.0239,0,0,1-2.9111,6.7988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M91.7125,28.5268a.3472.3472,0,0,0,.306.4324,2.5993,2.5993,0,0,0,1.3548-4.9517.3472.3472,0,0,0-.4835.2164Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.1,105.914a.3739.3739,0,0,1-.3643-.2881,4.0234,4.0234,0,1,1,7.8262-1.871.373.373,0,0,1-.2774.4511.3671.3671,0,0,1-.4511-.2773,3.2744,3.2744,0,0,0-6.3692,1.5234.373.373,0,0,1-.2773.4512A.3367.3367,0,0,1,57.1,105.914Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.4844,104.0978a.3472.3472,0,0,1-.1964-.492,2.5994,2.5994,0,0,1,4.8922,1.5563.3472.3472,0,0,1-.4446.2881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.9231,35.9238a.5989.5989,0,0,1-.2256-.0439L14.843,33.4736a.5989.5989,0,0,1-.3359-.3516.5687.5687,0,0,1,.0322-.457,3.7717,3.7717,0,0,1,6.9414,2.8525.5656.5656,0,0,1-.3.3477A.5949.5949,0,0,1,20.9231,35.9238Zm-.0361-.5068a.0912.0912,0,0,0,.0781-.003A3.2587,3.2587,0,0,0,14.9807,32.9c.0069.0791.0274.1005.0528.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.0823,41.0019a3.7795,3.7795,0,0,1-3.4014-5.417.5673.5673,0,0,1,.3526-.2939.599.599,0,0,1,.4785.0644l5.3916,3.3155a.5979.5979,0,0,1,.2744.3994.5684.5684,0,0,1-.1035.4472A3.757,3.757,0,0,1,77.0823,41.0019ZM74.2,35.7675a.0866.0866,0,0,0-.0274.004,3.26,3.26,0,0,0,5.5049,3.4433c.0039-.0791-.0127-.1045-.0351-.1181L74.25,35.7812A.1043.1043,0,0,0,74.2,35.7675Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.95,14.7715a.5984.5984,0,0,1-.2285-.045.5743.5743,0,0,1-.3184-.3261A6.1059,6.1059,0,0,1,46.5276,9.417.5666.5666,0,0,1,46.56,9.87a.5962.5962,0,0,1-.3173.35l-10.0508,4.501A.592.592,0,0,1,35.95,14.7715ZM41.1,6.6367a5.548,5.548,0,0,0-2.2764.4883,5.6094,5.6094,0,0,0-2.9541,7.0976c.0674.0518.0947.0537.1172.041L46.0374,9.7627a.0894.0894,0,0,0,.05-.0547A5.5941,5.5941,0,0,0,41.1,6.6367Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.6458,19.2451A3.777,3.777,0,0,1,3.24,18.9726a.5668.5668,0,0,1-.3183-.33.5971.5971,0,0,1,.03-.48l2.9307-5.6162a.5977.5977,0,0,1,.377-.3008.5567.5567,0,0,1,.4511.0723,3.7749,3.7749,0,0,1-2.0644,6.9277Zm-1.251-.8526a.0986.0986,0,0,0-.0049.0762,3.26,3.26,0,0,0,3.0469-5.7334c-.0772,0-.1.0186-.1113.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M58.5178,27.9443a.6458.6458,0,0,1-.1132-.0107.6.6,0,0,1-.3936-.2793L54.7727,22.21a.5942.5942,0,0,1-.0556-.48.561.561,0,0,1,.2978-.3457,3.7719,3.7719,0,0,1,3.836,6.4512A.5569.5569,0,0,1,58.5178,27.9443Zm-1.9062-6.416a3.2753,3.2753,0,0,0-1.3857.31c-.04.0654-.0362.0947-.0235.1171l3.2383,5.4434a.1006.1006,0,0,0,.0625.0449,3.26,3.26,0,0,0-1.8916-5.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.9524,109.7685c-.0146,0-.0283,0-.043-.001a.5917.5917,0,0,1-.4169-.2167l-6.2735-7.7a.5993.5993,0,0,1-.1269-.4581.5682.5682,0,0,1,.2353-.3906,5.5674,5.5674,0,0,1,7.0166,8.6143A.5749.5749,0,0,1,17.9524,109.7685Zm-3.4121-9.291a5.0279,5.0279,0,0,0-2.9238.9326c-.0332.0782-.0264.1055-.01.125l6.2734,7.7a.091.091,0,0,0,.0655.0332,5.047,5.047,0,0,0-3.4053-8.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M45.1682,45.3525a3.7544,3.7544,0,0,1-3.042-1.5537.57.57,0,0,1-.0937-.45.6.6,0,0,1,.2832-.3916l5.4648-3.1924a.5953.5953,0,0,1,.4815-.0537.5656.5656,0,0,1,.3447.3018,3.78,3.78,0,0,1-3.4385,5.34Zm2.8965-5.165a.0654.0654,0,0,0-.0322.0088l-5.4649,3.1923a.0985.0985,0,0,0-.0458.0635,3.2594,3.2594,0,0,0,5.6308-3.2314A.1794.1794,0,0,0,48.0647,40.1875Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.8841,56.6006a5.088,5.088,0,0,1-4.0372-8.1973.5767.5767,0,0,1,.4043-.22.596.596,0,0,1,.4522.1484h.001L14.4,54.3183a.6028.6028,0,0,1,.1982.4336.5713.5713,0,0,1-.1728.4248A5.08,5.08,0,0,1,10.8841,56.6006Zm-3.5782-7.92-.0088.001a4.5818,4.5818,0,0,0,6.78,6.1358c.0195-.0831.0078-.1084-.0117-.127L7.37,48.705A.0964.0964,0,0,0,7.3059,48.6806Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.2224,40.3661a.3335.3335,0,0,0-.1405.4768,2.6937,2.6937,0,0,0,4.7706-2.3953.3337.3337,0,0,0-.4664-.1721Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M49.8152,98.57a2.6933,2.6933,0,0,0-5.1718,1.5061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.5188,39.5771a.3751.3751,0,0,1-.1709-.709l4.7549-2.4316a.3752.3752,0,1,1,.3418.668L4.69,39.5361A.37.37,0,0,1,4.5188,39.5771Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.7641,25.1424a.3423.3423,0,0,0-.4183.2687A4.7426,4.7426,0,0,0,34.5447,27.61a.3423.3423,0,0,0-.2517-.4288Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.8772,25.9228a.3607.3607,0,0,1-.084-.01l-9.1621-2.1182a.3746.3746,0,0,1-.2812-.4492.3684.3684,0,0,1,.4492-.2813l9.1621,2.1182a.3749.3749,0,0,1-.084.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.9456,61.6463a.37.37,0,0,0-.1071-.532,3.8957,3.8957,0,0,0-4.4563,6.3426.37.37,0,0,0,.5368-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M33.5374,67.8525a.3706.3706,0,0,1-.2129-.0664.375.375,0,0,1-.0957-.5215l4.3935-6.3535a.3749.3749,0,1,1,.6172.4258L33.846,67.69A.3759.3759,0,0,1,33.5374,67.8525Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.6216,40.217a.343.343,0,0,0-.3941-.3037A4.8887,4.8887,0,0,0,58.29,49.6062a.343.343,0,0,0,.319-.3819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M59.97,48.123a.3747.3747,0,0,1-.3721-.331L58.47,38.165a.374.374,0,0,1,.3281-.416.37.37,0,0,1,.416.3281l1.128,9.627a.3741.3741,0,0,1-.3282.416A.3516.3516,0,0,1,59.97,48.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.4274,24.4755a.3424.3424,0,0,0-.0981-.4875A4.7551,4.7551,0,0,0,79.92,31.7773a.3423.3423,0,0,0,.491-.0784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M80.69,34.4121a.3749.3749,0,0,1-.31-.5869l5.32-7.7842a.3751.3751,0,1,1,.6191.4238l-5.32,7.7842A.3758.3758,0,0,1,80.69,34.4121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.0387,7.3574a.3374.3374,0,0,0,.1719-.4658,3.4421,3.4421,0,0,0-6.2915,2.7.3375.3375,0,0,0,.4561.1964Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M22.6507,12.1963a.3751.3751,0,0,1-.15-.7188L28.7512,8.74a.3752.3752,0,1,1,.3008.6875L22.801,12.165A.37.37,0,0,1,22.6507,12.1963Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.2671,70.8008a.343.343,0,0,0,.4811.127,4.8741,4.8741,0,0,0-4.7255-8.4961.3429.3429,0,0,0-.1459.4756Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.8938,73.5771a.3729.3729,0,0,1-.3262-.19l-4.76-8.41a.3747.3747,0,1,1,.6523-.3691l4.76,8.41a.3751.3751,0,0,1-.3262.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.5247,43.3271a1.0941,1.0941,0,0,1-.2569-.03,1.0671,1.0671,0,0,1-.7-.5527,5.6389,5.6389,0,0,1,9.0518-6.5029,1.0764,1.0764,0,0,1-.1445,1.625l-.2188-.3047.2188.3047-7.3223,5.26A1.0725,1.0725,0,0,1,30.5247,43.3271Zm4.0644-8.0146a4.8639,4.8639,0,0,0-2.8457.9092,4.919,4.919,0,0,0-1.5078,6.1826.3188.3188,0,0,0,.21.164.3317.3317,0,0,0,.27-.0517l7.3223-5.26a.3284.3284,0,0,0,.1357-.2393.3161.3161,0,0,0-.0888-.2509A4.8878,4.8878,0,0,0,34.5891,35.3125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.2659,46.72a.3749.3749,0,0,1-.2207-.6777l9.3486-6.8213a.3746.3746,0,1,1,.4414.6054l-9.3486,6.8213A.37.37,0,0,1,29.2659,46.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M74.77,17.7314a.7168.7168,0,0,1-.4385-.1494.6969.6969,0,0,1-.27-.4873,4.9253,4.9253,0,0,1,9.6846-1.6328.6988.6988,0,0,1-.0947.5478.7208.7208,0,0,1-.4825.3155l-8.2793,1.3965A.7035.7035,0,0,1,74.77,17.7314Zm4.19-5.2529a4.1151,4.1151,0,0,0-.6884.0576,4.1926,4.1926,0,0,0-3.4649,4.49L83.0208,15.59A4.2117,4.2117,0,0,0,78.96,12.4785Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.2346,19.3134a.3749.3749,0,0,1-.0654-.7441l9.8535-1.7363a.3749.3749,0,1,1,.1309.7383L76.3,19.3076A.38.38,0,0,1,76.2346,19.3134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M105.0608,100.03a.7227.7227,0,0,1-.4482-.1562.6905.6905,0,0,1-.2627-.4951,4.0151,4.0151,0,0,1,7.8808-1.3262.6962.6962,0,0,1-.0869.5527.7294.7294,0,0,1-.4883.3233l-6.4755,1.0918A.7131.7131,0,0,1,105.0608,100.03Zm3.3047-4.1923a3.3306,3.3306,0,0,0-.5527.0468,3.2512,3.2512,0,0,0-2.7149,3.4434l6.4112-1.1357A3.2655,3.2655,0,0,0,108.3655,95.8379Zm3.165,2.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.13,63.9433a.596.596,0,0,1-.3964-.1513.5712.5712,0,0,1-.1914-.417,4.2927,4.2927,0,0,1,8.5107-.8438.5657.5657,0,0,1-.1045.4444.6007.6007,0,0,1-.418.2373H24.53l-7.3409.7275A.5734.5734,0,0,1,17.13,63.9433Zm3.6983-4.4082a3.5885,3.5885,0,0,0-.3682.0186,3.8147,3.8147,0,0,0-3.4179,3.8154c.0449.0684.0771.08.0966.0733l7.3409-.7276a.0935.0935,0,0,0,.0673-.0381A3.7936,3.7936,0,0,0,20.8284,59.5351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.2044,65.5449a.25.25,0,0,1-.0264-.499l8.8379-.9424a.2554.2554,0,0,1,.2754.2226.2508.2508,0,0,1-.2227.2754l-8.8379.9424Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.4885,10.9013a4.22,4.22,0,0,1-1.2626-.1933.57.57,0,0,1-.3438-.3028.6021.6021,0,0,1-.0117-.4794l2.8105-6.8223a.5982.5982,0,0,1,.3457-.3311.5574.5574,0,0,1,.4551.0274,4.2909,4.2909,0,0,1-1.9932,8.1015Zm1.7637-7.6582c-.0781.0078-.0986.0274-.1084.0518l-2.81,6.8223a.0982.0982,0,0,0,.0019.0761,3.78,3.78,0,0,0,2.917-6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.6975,9.5019a.2463.2463,0,0,1-.0937-.0185.2493.2493,0,0,1-.1377-.3252L53.79.914a.25.25,0,1,1,.4629.1875L50.929,9.3457A.25.25,0,0,1,50.6975,9.5019Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.1936,111.1162a.2464.2464,0,0,1-.0937-.0186.2491.2491,0,0,1-.1377-.3252l3.3242-8.2431a.25.25,0,0,1,.4629.1875l-3.3242,8.2431A.25.25,0,0,1,106.1936,111.1162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.9563,111.623a4.2214,4.2214,0,0,1-1.2627-.1933.5693.5693,0,0,1-.3437-.3028.6.6,0,0,1-.0117-.4785l2.81-6.8232a.5927.5927,0,0,1,.3457-.3311.5606.5606,0,0,1,.4551.0274,4.2908,4.2908,0,0,1-1.9922,8.1015Zm1.7627-7.6582c-.0791.0078-.0986.0274-.1084.0508l-2.81,6.8232a.0989.0989,0,0,0,.002.0762,3.7927,3.7927,0,0,0,4.6777-2.1377A3.8156,3.8156,0,0,0,4.719,103.9648Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.5866,111.1162a.2469.2469,0,0,1-.0938-.0186.2492.2492,0,0,1-.1377-.3252l3.3242-8.2431a.25.25,0,0,1,.4629.1875L-.3552,110.96A.25.25,0,0,1-.5866,111.1162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M96.7385,95.68a6.6214,6.6214,0,0,1-5.788-9.81.5.5,0,1,1,.8769.4824,5.6161,5.6161,0,1,0,9.8408,5.415.5.5,0,0,1,.877.4825,6.573,6.573,0,0,1-3.9531,3.165A6.6679,6.6679,0,0,1,96.7385,95.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.2637,87.01a.3437.3437,0,0,0-.477.15,4.357,4.357,0,0,0,7.61,4.184.3405.3405,0,0,0-.128-.4794Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.7153,50.7846a.3452.3452,0,0,0,.3738-.3275,6.3129,6.3129,0,0,0-12.5634-1.03.3451.3451,0,0,0,.3155.3841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M113.7128,31.0109a.3453.3453,0,0,0,.3739-.3276,6.313,6.313,0,0,0-12.5636-1.03.3453.3453,0,0,0,.3155.3841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.0731,111.7173a.3452.3452,0,0,0-.1148.4836,6.313,6.313,0,0,0,10.8338-6.4446.3451.3451,0,0,0-.48-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.3108,77.9818a.3453.3453,0,0,0,.4321-.2457,6.3129,6.3129,0,0,0-12.1-3.5344.3453.3453,0,0,0,.2319.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M46.4959,73.95a.3437.3437,0,0,0-.132-.48,5.0847,5.0847,0,0,0-5.1827,8.72.3438.3438,0,0,0,.4848-.1135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.5139,73.3037a7.4126,7.4126,0,0,1-7.1445-9.3682.5.5,0,1,1,.9649.2637,6.41,6.41,0,1,0,12.3642,3.3867.5.5,0,0,1,.9649.2637A7.4245,7.4245,0,0,1,62.5139,73.3037Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.6688,64.4105a.3717.3717,0,0,0-.4653.276,4.9221,4.9221,0,0,0,9.4556,2.6249.3719.3719,0,0,0-.2564-.4764Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M60.8264,86.46a.4992.4992,0,0,1-.4882-.3935,7.09,7.09,0,1,1,13.8554-3.02.5.5,0,1,1-.9765.2129,6.0909,6.0909,0,0,0-11.9024,2.5938.5007.5007,0,0,1-.4883.6064Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M71.5,83.8505a.3421.3421,0,0,0,.26-.4236,4.695,4.695,0,0,0-9.1478,1.9939.3422.3422,0,0,0,.4128.277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M91.83,60.7a6.1493,6.1493,0,0,1-5.7656-4.0147.3748.3748,0,1,1,.7031-.26,5.3867,5.3867,0,0,0,10.1094-3.7237.3748.3748,0,1,1,.7031-.26A6.1368,6.1368,0,0,1,91.83,60.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M87.4214,55.972a.3391.3391,0,0,0-.1975.4543,4.1038,4.1038,0,0,0,7.6729-2.8239.3422.3422,0,0,0-.4483-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.1966,41.542a.375.375,0,0,1-.001-.75,5.1358,5.1358,0,0,0-.0186-10.2715h-.02a.3755.3755,0,0,1-.375-.374.3878.3878,0,0,1,.3945-.376,5.8858,5.8858,0,0,1,.02,11.7715Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.8994,39.963a.3411.3411,0,0,0,.3622.3427,3.9257,3.9257,0,0,0-.028-7.8181.3411.3411,0,0,0-.36.3453Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M104.1985,80.9375a.3741.3741,0,0,1-.3721-.3321A5.8857,5.8857,0,1,1,115.52,79.2529a.3731.3731,0,0,1-.3291.415.3673.3673,0,0,1-.415-.3291A5.1366,5.1366,0,1,0,104.5706,80.52a.3731.3731,0,0,1-.3291.415A.3219.3219,0,0,1,104.1985,80.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.0907,79.6807a.3411.3411,0,0,0,.3-.3981,3.9257,3.9257,0,0,0-7.7664.8982.3409.3409,0,0,0,.3831.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.0872,51.0634A5.509,5.509,0,0,1,84.83,43.92a.38.38,0,0,1,.47-.2471.3752.3752,0,0,1,.247.47,4.7583,4.7583,0,0,0,9.0879,2.8243.3794.3794,0,0,1,.47-.2471.3752.3752,0,0,1,.247.47A5.52,5.52,0,0,1,90.0872,51.0634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88.3828,44.6714a.3352.3352,0,0,0-.4318.2427A3.1972,3.1972,0,0,0,94.0185,46.8.3353.3353,0,0,0,93.8,46.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M94.5784,80.6543c-.1065,0-.2129-.003-.32-.0088a5.6354,5.6354,0,0,1-3.9121-1.8809.5.5,0,0,1,.7461-.666,4.67,4.67,0,1,0,6.958-6.2305.5.5,0,0,1,.7461-.666,5.6705,5.6705,0,0,1-4.2178,9.4522Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M91.2964,75.8606a.3394.3394,0,0,0-.2351.4387,3.6827,3.6827,0,0,0,7.068-1.9419.34.34,0,0,0-.4262-.257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M42.6389,92.8974a6.6226,6.6226,0,0,1-4.9463-2.206.5.5,0,0,1,.7442-.668,5.6351,5.6351,0,0,0,8.3975-7.5166.4993.4993,0,1,1,.7441-.666,6.6322,6.6322,0,0,1-4.94,11.0566Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M38.7041,87.3194a.36.36,0,0,0-.25.4633A4.37,4.37,0,0,0,46.85,85.48a.3639.3639,0,0,0-.455-.2731Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.6985,87.666a4.02,4.02,0,0,1-3.082-1.4307l.5742-.4824A3.2737,3.2737,0,1,0,84.2,81.5361l.5742-.4824a4.0213,4.0213,0,0,1-3.0752,6.6123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.09,85.7125a.3471.3471,0,0,0,.279.45,2.5993,2.5993,0,0,0,1.6548-4.86.347.347,0,0,0-.4958.1864Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.2815,69.7265a3.7795,3.7795,0,0,1-3.64-4.7939.564.564,0,0,1,.2949-.3526.5887.5887,0,0,1,.4834-.02l5.89,2.3184a.5986.5986,0,0,1,.34.3457.5654.5654,0,0,1-.0254.459A3.7553,3.7553,0,0,1,92.2815,69.7265Zm-3.0791-4.709a.0975.0975,0,0,0-.0439.0108A3.259,3.259,0,0,0,95.18,67.4531c-.0079-.0791-.0284-.1006-.0538-.11l-5.89-2.3183A.1017.1017,0,0,0,89.2024,65.0175Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M68.7307,96.9111A6.0843,6.0843,0,0,1,64.2171,94.92a.5767.5767,0,0,1-.1485-.4326.5987.5987,0,0,1,.2207-.42l8.5635-6.9112a.5928.5928,0,0,1,.458-.126.5785.5785,0,0,1,.3936.2354,6.1053,6.1053,0,0,1-4.9737,9.6455Zm4.4971-9.3867a.0942.0942,0,0,0-.0605.02L64.6018,94.458a.0945.0945,0,0,0-.0342.0664,5.593,5.593,0,0,0,8.7305-6.9678.084.084,0,0,0-.0556-.0312Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.4407,88.5791a.5793.5793,0,0,1-.1465-.0186l-6.1377-1.5459a.5962.5962,0,0,1-.3808-.2978.5693.5693,0,0,1-.0342-.458,3.7716,3.7716,0,0,1,7.2773,1.832.564.564,0,0,1-.247.3877A.5945.5945,0,0,1,106.4407,88.5791Zm-3.1631-4.3067a3.2548,3.2548,0,0,0-3.0654,2.1563c.0176.0771.041.0947.0664.1015l6.1387,1.5459a.0938.0938,0,0,0,.0771-.0136,3.233,3.233,0,0,0-2.4082-3.6895A3.345,3.345,0,0,0,103.2776,84.2724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.052,103.1631a3.7776,3.7776,0,0,1-3.7783-3.9678.5677.5677,0,0,1,.21-.4082.6022.6022,0,0,1,.4687-.126l6.2539.9658a.5979.5979,0,0,1,.4072.2627.5659.5659,0,0,1,.0782.4512A3.7552,3.7552,0,0,1,93.052,103.1631Zm-3.1914-4.0088a.1.1,0,0,0-.0615.0215,3.26,3.26,0,0,0,6.4082,1.041c-.0264-.0752-.0518-.0918-.0781-.0957l-6.2549-.9659Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.679,79.9365a3.7755,3.7755,0,0,1-2.2862-6.7725.5555.5555,0,0,1,.4483-.1045.5976.5976,0,0,1,.3984.2754l3.3155,5.3907a.5969.5969,0,0,1,.0644.4785.5657.5657,0,0,1-.2949.3525A3.7681,3.7681,0,0,1,53.679,79.9365Zm-1.9307-6.3857a3.2594,3.2594,0,0,0,3.3574,5.5566c.0411-.0684.0371-.0977.0235-.12l-3.3174-5.3926A.0987.0987,0,0,0,51.7483,73.5508Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.0813,61.3515a.6022.6022,0,0,1-.165-.0234.5657.5657,0,0,1-.3535-.29,5.1062,5.1062,0,0,1,8.7177-5.2666.5768.5768,0,0,1,.0918.45.5962.5962,0,0,1-.2754.3886L61.39,61.2656A.5936.5936,0,0,1,61.0813,61.3515Zm4.0078-7.2265a4.551,4.551,0,0,0-2.3564.6562,4.6216,4.6216,0,0,0-1.7246,6.03c.0722.043.1006.0371.124.0264l7.707-4.6553a.0992.0992,0,0,0,.044-.0635A4.6086,4.6086,0,0,0,65.0891,54.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.3362,52.1279a.6043.6043,0,0,1-.3916-.1445v-.001L99.16,46.0957a.597.597,0,0,1-.2041-.43.5756.5756,0,0,1,.168-.4287A5.0953,5.0953,0,0,1,106.8,51.8984a.5768.5768,0,0,1-.4014.2256A.4522.4522,0,0,1,106.3362,52.1279Zm-.0635-.5225a.0792.0792,0,0,0,.0733.0215,4.5814,4.5814,0,0,0-6.8692-6.0351c-.0195.084-.0078.1093.0117.1259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M41.8548,69.0088a6.43,6.43,0,0,1-3.06-.7745.5767.5767,0,0,1-.2832-.3593.6036.6036,0,0,1,.0674-.4678l6.1377-9.998a.6.6,0,0,1,.3857-.2715.5783.5783,0,0,1,.45.0888,6.47,6.47,0,0,1-3.6982,11.7823Zm-2.85-1.34a.0959.0959,0,0,0-.01.0752.0758.0758,0,0,0,.0371.0508,5.9689,5.9689,0,0,0,6.2353-10.1572.0792.0792,0,0,0-.0625-.0108.1.1,0,0,0-.0625.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M95.677,115.8037a7.4807,7.4807,0,0,1-3.5644-.9024.6338.6338,0,0,1-.3125-.3974.6594.6594,0,0,1,.0742-.5127l7.1963-11.7237a.6582.6582,0,0,1,.4258-.2988.637.637,0,0,1,.4941.1,7.5429,7.5429,0,0,1-4.3135,13.7354Zm3.9522-13.3487a.1264.1264,0,0,0-.0313.004.1568.1568,0,0,0-.1015.07L92.3,114.2529a.1565.1565,0,0,0-.0166.1221.1365.1365,0,0,0,.0664.0869,7.0415,7.0415,0,0,0,7.3545-11.9834A.1366.1366,0,0,0,99.6292,102.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M107.738,57.4472a.3337.3337,0,0,0,.1335-.4789,2.6937,2.6937,0,0,0-4.7346,2.4657.3335.3335,0,0,0,.4688.1652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M105.5667,60.1611a.375.375,0,0,1-.1758-.7061l4.7187-2.5009a.3748.3748,0,1,1,.3516.6621l-4.7187,2.501A.3677.3677,0,0,1,105.5667,60.1611Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.6092,94.206a.3363.3363,0,0,0,.1361-.4768,3.3044,3.3044,0,0,0-5.8282,3.03.34.34,0,0,0,.4733.1642Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.8128,98.8593a.3749.3749,0,0,1-.1758-.706l5.7881-3.0693a.3748.3748,0,1,1,.3515.6621l-5.7881,3.0693A.3659.3659,0,0,1,20.8128,98.8593Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.8093,75.6139a.4023.4023,0,0,0,.4868-.3229,5.572,5.572,0,0,0-10.8448-2.4227.4021.4021,0,0,0,.303.4993Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.76,76.8457a.3744.3744,0,0,1-.0791-.0088l-9.1924-1.9824a.3747.3747,0,0,1,.1583-.7325l9.1923,1.9825a.3748.3748,0,0,1-.0791.7412Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M52.8755,58.6352a.34.34,0,0,0,.4516.21,3.7346,3.7346,0,0,0-2.38-7.043.34.34,0,0,0-.2319.4406Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.9085,60.5566a.376.376,0,0,1-.3545-.2519l-2.4219-6.9971a.3752.3752,0,1,1,.709-.2461l2.4219,6.9971a.3757.3757,0,0,1-.2315.4775A.386.386,0,0,1,51.9085,60.5566Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M79.4289,96.1172a.3394.3394,0,0,0-.1661.4692,3.6994,3.6994,0,0,0,6.7231-3.0035.34.34,0,0,0-.46-.1894Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M78.5413,95.3564a.3748.3748,0,0,1-.1553-.7158l6.6748-3.042a.3745.3745,0,0,1,.3106.6816l-6.6748,3.042A.3652.3652,0,0,1,78.5413,95.3564Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.024,36.8466a.34.34,0,0,0,.2351-.4392,3.8089,3.8089,0,0,0-7.31,2.0188.34.34,0,0,0,.4272.2563Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M98.346,40.8476a.3748.3748,0,0,1-.1026-.7353l7.2637-2.0635a.3747.3747,0,1,1,.2051.7207L98.4485,40.833A.3744.3744,0,0,1,98.346,40.8476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M75.4358,65.1953a5.6394,5.6394,0,0,1-4.7851-2.6377.7008.7008,0,0,1-.0811-.55.7159.7159,0,0,1,.3506-.4444l8.6553-4.6679a.72.72,0,0,1,.5683-.0469.6982.6982,0,0,1,.4112.3691,5.6339,5.6339,0,0,1-5.1192,7.9776ZM71.3,62.21a4.8964,4.8964,0,0,0,8.5722-4.6806Zm-.0244.0137-.001.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.5325,60.6435a.3751.3751,0,0,1-.1807-.7041l10.1446-5.5683a.3754.3754,0,0,1,.3613.6582L70.7132,60.5976A.3763.3763,0,0,1,70.5325,60.6435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.8372,110.9834a.7136.7136,0,0,1-.4522-.1612,5.7438,5.7438,0,0,1,6.7168-9.2871.7061.7061,0,0,1,.3174.4639.73.73,0,0,1-.124.5684l-5.8682,8.1152a.73.73,0,0,1-.59.3008Zm3.2471-9.5762a4.9979,4.9979,0,0,0-3.2208,8.8379l5.8155-8.1045A4.9268,4.9268,0,0,0,74.0843,101.4072Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M73.3147,111.2871a.3749.3749,0,0,1-.3056-.5928l6.8466-9.6162a.3753.3753,0,0,1,.6114.4355L73.62,111.13A.3749.3749,0,0,1,73.3147,111.2871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M29.3294,88.7842a4.95,4.95,0,0,1-4.7686-3.66.6954.6954,0,0,1,.0879-.5527.7262.7262,0,0,1,.4785-.3223l8.2539-1.5176a.72.72,0,0,1,.5615.1328.6952.6952,0,0,1,.2774.4854,4.919,4.919,0,0,1-4.8906,5.4346Zm-4.0459-3.8008a4.1839,4.1839,0,0,0,8.19-1.5567Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.9934,83.2783a.3749.3749,0,0,1-.07-.7432L34.75,80.6533a.3748.3748,0,0,1,.1406.7363l-9.8272,1.8819A.3482.3482,0,0,1,24.9934,83.2783Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M88.8782,41.3955a4.3207,4.3207,0,0,1-4.2119-3.4326.5711.5711,0,0,1,.1-.4483.5989.5989,0,0,1,.4141-.24l7.3281-.8369a.5912.5912,0,0,1,.459.1425.5662.5662,0,0,1,.1963.4141,4.3172,4.3172,0,0,1-3.8047,4.374A4.1869,4.1869,0,0,1,88.8782,41.3955Zm3.6943-4.4619h-.0078l-7.3291.8369a.0963.0963,0,0,0-.0654.039,3.78,3.78,0,0,0,7.4932-.8027C92.6233,36.9463,92.5969,36.9336,92.5725,36.9336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.13,36.3037a.25.25,0,0,1-.03-.4981l8.8232-1.0732a.25.25,0,0,1,.0606.4961L85.16,36.3017Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M55.4065,98.68a.5669.5669,0,0,1-.2568-.0616A4.51,4.51,0,0,1,58.4446,90.26a.5894.5894,0,0,1,.3594.3086.614.614,0,0,1,.02.4942v.0009L55.9719,98.291a.6188.6188,0,0,1-.3525.3486A.5994.5994,0,0,1,55.4065,98.68Zm1.7764-8.1036a4.0089,4.0089,0,0,0-1.8106,7.5948.0924.0924,0,0,0,.0684.0019.1179.1179,0,0,0,.0664-.0654L58.36,90.8808a.12.12,0,0,0-.0048-.0937.09.09,0,0,0-.0538-.0488A3.94,3.94,0,0,0,57.1829,90.5761Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M57.805,97.3672a.2405.2405,0,0,1-.09-.0166.25.25,0,0,1-.1435-.3233l3.2011-8.292a.25.25,0,0,1,.4668.18l-3.2011,8.292A.25.25,0,0,1,57.805,97.3672Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.8008,70.16a.343.343,0,0,0,.4425-.2275,4.8993,4.8993,0,0,0-3.15-5.8792,4.8993,4.8993,0,0,0-6.0942,2.7107.343.343,0,0,0,.21.4511Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1.6919,100.03A.7228.7228,0,0,1-2.14,99.874a.6905.6905,0,0,1-.2627-.4951A3.9974,3.9974,0,0,1,.935,95.1445a4.0011,4.0011,0,0,1,4.543,2.9082.6966.6966,0,0,1-.0869.5527.73.73,0,0,1-.4883.3233l-6.4756,1.0918A.712.712,0,0,1-1.6919,100.03Zm3.3046-4.1923a3.3315,3.3315,0,0,0-.5527.0468,3.251,3.251,0,0,0-2.7148,3.4434l6.4111-1.1357A3.2654,3.2654,0,0,0,1.6127,95.8379Zm3.1651,2.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.5591,111.1162a.2469.2469,0,0,1-.0938-.0186.2493.2493,0,0,1-.1377-.3252l3.3242-8.2431a.25.25,0,0,1,.4629.1875L-.3277,110.96A.25.25,0,0,1-.5591,111.1162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.96,31.0109a.3452.3452,0,0,0,.3738-.3276A6.313,6.313,0,0,0-5.23,29.6529a.3452.3452,0,0,0,.3155.3841Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2.5542,80.9375a.3741.3741,0,0,1-.3721-.3321,5.8839,5.8839,0,0,1,5.17-6.5234A5.8856,5.8856,0,0,1,8.767,79.2529a.373.373,0,0,1-.3291.415.3673.3673,0,0,1-.415-.3291A5.1366,5.1366,0,1,0-2.1822,80.52a.3731.3731,0,0,1-.3291.415A.32.32,0,0,1-2.5542,80.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.3379,79.6807a.3412.3412,0,0,0,.3-.3981,3.9258,3.9258,0,0,0-7.7665.8982.341.341,0,0,0,.3832.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.3121,88.5791a.5785.5785,0,0,1-.1464-.0186l-6.1377-1.5459a.5964.5964,0,0,1-.3809-.2978.5693.5693,0,0,1-.0342-.458,3.751,3.751,0,0,1,4.4668-2.37A3.756,3.756,0,0,1,.2661,88.0908a.5641.5641,0,0,1-.2471.3877A.5941.5941,0,0,1-.3121,88.5791Zm-3.163-4.3067a3.2549,3.2549,0,0,0-3.0655,2.1563c.0176.0771.041.0947.0664.1015l6.1387,1.5459a.094.094,0,0,0,.0772-.0136A3.233,3.233,0,0,0-2.6666,84.373,3.3442,3.3442,0,0,0-3.4751,84.2724Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.4166,52.1279a.6045.6045,0,0,1-.3916-.1445v-.001l-6.7841-5.8867a.5962.5962,0,0,1-.2041-.43.5751.5751,0,0,1,.1679-.4287,5.113,5.113,0,0,1,6.9327-.2354,5.1113,5.1113,0,0,1,.7431,6.8965.5768.5768,0,0,1-.4014.2256A.4512.4512,0,0,1-.4166,52.1279ZM-.48,51.6054a.079.079,0,0,0,.0732.0215,4.58,4.58,0,0,0-.6172-6.248,4.6115,4.6115,0,0,0-6.2519.2129c-.02.084-.0078.1093.0117.1259Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.9853,57.4472a.3336.3336,0,0,0,.1334-.4789,2.6939,2.6939,0,0,0-3.4436-.834,2.694,2.694,0,0,0-1.291,3.3.3336.3336,0,0,0,.4689.1652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1.1861,60.1611a.3746.3746,0,0,1-.331-.1992.3742.3742,0,0,1,.1552-.5069l4.7188-2.5009a.3748.3748,0,1,1,.3515.6621L-1.01,60.1172A.3674.3674,0,0,1-1.1861,60.1611Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.1661,4.3634a.2463.2463,0,0,1-.0937-.0185.2492.2492,0,0,1-.1377-.3252l3.3242-8.2432a.2478.2478,0,0,1,.3252-.1377.2493.2493,0,0,1,.1377.3252l-3.3242,8.2432A.25.25,0,0,1,106.1661,4.3634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M39.08-4.1917a.3452.3452,0,0,0-.3787.3219A6.3129,6.3129,0,0,0,44.4,2.6664a6.3129,6.3129,0,0,0,6.8481-5.32.3452.3452,0,0,0-.31-.3887Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M30.4954,1.4728a.3837.3837,0,0,1-.1592-.0352,5.6666,5.6666,0,0,1-2.9434-3.2207,5.6686,5.6686,0,0,1,.1963-4.3584A5.6644,5.6644,0,0,1,30.81-9.0838a5.6672,5.6672,0,0,1,4.3584.1963.3755.3755,0,0,1,.1807.499.3765.3765,0,0,1-.499.1806,4.9123,4.9123,0,0,0-3.7842-.1709,4.9179,4.9179,0,0,0-2.7969,2.5557,4.9152,4.9152,0,0,0-.17,3.7852A4.91,4.91,0,0,0,30.6546.758a.3751.3751,0,0,1-.1592.7148Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.9524,3.0158c-.0146,0-.0283,0-.043-.001a.5915.5915,0,0,1-.4169-.2168l-6.2735-7.7a.5989.5989,0,0,1-.1269-.458.568.568,0,0,1,.2353-.3906,5.577,5.577,0,0,1,7.5381,1.0244,5.577,5.577,0,0,1-.5215,7.59A.5745.5745,0,0,1,17.9524,3.0158ZM14.54-6.2752a5.0279,5.0279,0,0,0-2.9238.9326c-.0332.0781-.0264.1054-.01.125l6.2734,7.7a.0917.0917,0,0,0,.0655.0332A5.0487,5.0487,0,0,0,18.4788-4.41,5.0716,5.0716,0,0,0,14.54-6.2752Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.1936,4.3634a.2463.2463,0,0,1-.0937-.0185.2492.2492,0,0,1-.1377-.3252l3.3242-8.2432a.2478.2478,0,0,1,.3252-.1377.2493.2493,0,0,1,.1377.3252l-3.3242,8.2432A.25.25,0,0,1,106.1936,4.3634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2.9563,4.87a4.2184,4.2184,0,0,1-1.2627-.1934A.5692.5692,0,0,1,1.35,4.3742a.6.6,0,0,1-.0117-.4785l2.81-6.8233a.5922.5922,0,0,1,.3457-.331.561.561,0,0,1,.4551.0273A4.3175,4.3175,0,0,1,6.9436,2.214,4.3269,4.3269,0,0,1,2.9563,4.87ZM4.719-2.7879c-.0791.0078-.0986.0273-.1084.0507L1.801,4.0861a.0989.0989,0,0,0,.002.0762A3.7929,3.7929,0,0,0,6.4807,2.0246,3.8156,3.8156,0,0,0,4.719-2.7879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.5866,4.3634A.2468.2468,0,0,1-.68,4.3449.2493.2493,0,0,1-.8181,4.02L2.5061-4.2235a.2478.2478,0,0,1,.3252-.1377.2492.2492,0,0,1,.1377.3252L-.3552,4.2072A.25.25,0,0,1-.5866,4.3634Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M77.0731,4.9645a.3453.3453,0,0,0-.1148.4837A6.313,6.313,0,0,0,87.7921-.9965a.3451.3451,0,0,0-.48-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M95.677,9.0509a7.4817,7.4817,0,0,1-3.5644-.9023A.634.634,0,0,1,91.8,7.7511a.66.66,0,0,1,.0742-.5127L99.0706-4.4852a.6582.6582,0,0,1,.4258-.2988.6366.6366,0,0,1,.4941.1A7.5428,7.5428,0,0,1,95.677,9.0509ZM99.6292-4.2977a.127.127,0,0,0-.0313.0039.1575.1575,0,0,0-.1015.07L92.3,7.5a.1566.1566,0,0,0-.0166.1221.136.136,0,0,0,.0664.0869A7.0415,7.0415,0,0,0,99.7044-4.2743.1373.1373,0,0,0,99.6292-4.2977Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M70.8372,4.2306a.7135.7135,0,0,1-.4522-.1611,5.7569,5.7569,0,0,1-.9814-7.7832,5.7537,5.7537,0,0,1,7.6982-1.5039.7061.7061,0,0,1,.3174.4638.73.73,0,0,1-.124.5684L71.427,3.93a.7285.7285,0,0,1-.59.3008Zm3.2471-9.5762A5.0235,5.0235,0,0,0,70.011-3.2743a5.0059,5.0059,0,0,0,.8525,6.7666L76.679-4.6122A4.9268,4.9268,0,0,0,74.0843-5.3456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M73.3147,4.5343a.3748.3748,0,0,1-.3056-.5927l6.8466-9.6163a.377.377,0,0,1,.5235-.0878.3762.3762,0,0,1,.0879.5234L73.62,4.3771A.3749.3749,0,0,1,73.3147,4.5343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-.5591,4.3634a.2468.2468,0,0,1-.0938-.0185A.2493.2493,0,0,1-.7906,4.02L2.5336-4.2235a.2479.2479,0,0,1,.3252-.1377.2492.2492,0,0,1,.1377.3252L-.3277,4.2072A.25.25,0,0,1-.5591,4.3634Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M120.0824,96.629s19.8821-30.4249,0-65.0838C100.3318-2.8845,63.7183-.9967,63.7183-.9967V64.0871Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 186.6614,
    height: 106.7528,
    patternTransform: "translate(-528.447 296.4748) scale(1.12)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 186.661 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 186.6614,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S210.08,3.162,213.4989,3.162s9.9248,3.0536,13.344,3.0536S236.7677,3.162,240.187,3.162s9.9248,3.0536,13.3441,3.0536S263.01,3.162,266.8752,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,21.71,213.4989,21.71s9.9248,3.0535,13.344,3.0535S236.7677,21.71,240.187,21.71s9.9248,3.0535,13.3441,3.0535S263.01,21.71,266.8752,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S223.4237,29.4,226.8429,29.4s9.9248-3.0535,13.3441-3.0535S250.1118,29.4,253.5311,29.4s9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,8.1079a35.8009,35.8009,0,0,1,8.4963,1.6738"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8107,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8466,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8466,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.1155,95.9,213.5348,95.9s9.9248,3.0535,13.3441,3.0535S236.8037,95.9,240.223,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.8107,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.8107,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M186.7834,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M186.75,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8107,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0018,1.1764,8.3829,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8107,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.7835,59.1683c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.344-3.0536,9.9249,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.8107,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,81.99,213.4989,81.99s9.9248,3.0535,13.344,3.0535S236.7677,81.99,240.187,81.99s9.9248,3.0535,13.3441,3.0535S263.01,81.99,266.8752,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,95.9325a35.8016,35.8016,0,0,1,8.4963,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342-1.4749,186.6-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,3.162,106.535,3.162s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,3.162,186.6,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,12.434,186.6,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,8.1079,186.6,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,29.4,119.8791,29.4s9.9248-3.0535,13.3441-3.0535S143.148,29.4,146.5673,29.4s9.9248-3.0535,13.3441-3.0535S169.8362,29.4,173.2555,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,35.72,106.535,35.72s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,35.72,186.6,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M177.9619,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M79.8468,45.01c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,45.01,106.535,45.01s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536c2.3479,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.8468,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M98.223,55.8681c3.338-.8912,5.8476-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.344-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M79.82,54.168c2.1968,0,4.6971.8519,7.96,1.7561"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M79.7865,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M151.7094,69.9205c3.4654-.8393,5.5849-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,68.0788c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M151.7094,23.4241c3.4654-.8394,5.5849-1.8418,8.202-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,21.5823c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1765,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M79.82,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.8468,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,89.68,119.8791,89.68s9.9248-3.0535,13.3441-3.0535S143.148,89.68,146.5673,89.68s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,81.99,106.535,81.99s9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,81.99,186.6,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,95.9,106.535,95.9s9.9248,3.0535,13.3441,3.0535S129.8039,95.9,133.2232,95.9s9.9248,3.0535,13.3441,3.0535S156.4921,95.9,159.9114,95.9s9.9248,3.0535,13.3441,3.0535S182.7342,95.9,186.6,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.934,21.4334l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3853.3853,0,0,0-.1108.341l.2694,1.5708a.3853.3853,0,0,1-.559.4062l-1.4107-.7417a.3852.3852,0,0,0-.3585,0l-1.4107.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341L143.4569,23.96a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,146.934,21.4334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M124.7313,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,100.846c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535a35.8023,35.8023,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.1818,100.6971l.7053,1.4292a.3855.3855,0,0,0,.29.2108l1.5772.2291a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3856.3856,0,0,0-.1108.3411l.2695,1.5708a.3853.3853,0,0,1-.559.4061l-1.4107-.7416a.3854.3854,0,0,0-.3586,0l-1.4107.7416a.3853.3853,0,0,1-.559-.4061l.2694-1.5708a.3853.3853,0,0,0-.1108-.3411l-1.1412-1.1124a.3853.3853,0,0,1,.2135-.6572l1.5772-.2291a.3856.3856,0,0,0,.29-.2108l.7053-1.4292A.3853.3853,0,0,1,120.1818,100.6971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M173.5041,45.398l.5889,1.1932a.3215.3215,0,0,0,.2421.1759l1.3168.1914a.3216.3216,0,0,1,.1783.5486l-.9528.9288a.3215.3215,0,0,0-.0926.2847l.225,1.3114a.3217.3217,0,0,1-.4667.3391l-1.1778-.6192a.3219.3219,0,0,0-.2993,0l-1.1778.6192a.3216.3216,0,0,1-.4667-.3391l.2249-1.3114a.3217.3217,0,0,0-.0925-.2847l-.9528-.9288a.3216.3216,0,0,1,.1783-.5486l1.3167-.1914a.3215.3215,0,0,0,.2422-.1759l.5889-1.1932A.3217.3217,0,0,1,173.5041,45.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.2775,54.7432l.6041,1.2241a.33.33,0,0,0,.2485.1806l1.3509.1962a.33.33,0,0,1,.1829.5629l-.9775.9528a.33.33,0,0,0-.0949.2921l.2307,1.3454a.33.33,0,0,1-.4788.3479L93.1351,59.21a.33.33,0,0,0-.3071,0l-1.2082.6352a.33.33,0,0,1-.4788-.3479l.2307-1.3454a.33.33,0,0,0-.0949-.2921l-.9775-.9528a.33.33,0,0,1,.1829-.5629l1.3509-.1962a.33.33,0,0,0,.2484-.1806l.6042-1.2241A.33.33,0,0,1,93.2775,54.7432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M146.8845,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3508.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2308,1.3455a.33.33,0,0,1-.4788.3478l-1.2083-.6352a.33.33,0,0,0-.3071,0l-1.2083.6352a.33.33,0,0,1-.4788-.3478l.2308-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6041-1.2241A.33.33,0,0,1,146.8845,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,1.5787,66.87,1.5787s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S23.4181,3.162,26.8374,3.162s9.9248,3.0536,13.3441,3.0536S50.1063,3.162,53.5256,3.162,63.45,6.2156,66.87,6.2156,76.3484,3.162,80.2138,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,15.4875,66.87,15.4875s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,20.1263,66.87,20.1263s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,21.71,26.8374,21.71s9.9248,3.0535,13.3441,3.0535S50.1063,21.71,53.5256,21.71,63.45,24.7632,66.87,24.7632,76.3484,21.71,80.2138,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,29.4,40.1815,29.4s9.9248-3.0535,13.3441-3.0535S63.45,29.4,66.87,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M18.3456,9.7852a36.6744,36.6744,0,0,1,8.6386-1.6773c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,8.1079A35.8006,35.8006,0,0,1,8.6456,9.7817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1492,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,43.3108,66.87,43.3108s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M71.6121,37.4737C74.8345,36.58,77.5107,35.72,80.25,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1852,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M71.6121,97.8625c3.2224-.8935,5.8986-1.7532,8.6377-1.7532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1852,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4541,95.9,26.8734,95.9s9.9248,3.0535,13.3441,3.0535S50.1423,95.9,53.5616,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1492,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,33.6068,66.87,33.6068s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M.1492,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,47.9478,66.87,47.9478s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M.122,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M.0889,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S50.046,54.168,53.4653,54.168s9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M45.3236,69.9205c3.4654-.8393,5.585-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1492,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.492,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1492,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,66.4954,66.87,66.4954s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M.1221,59.1683c3.4192,0,9.9248,3.0536,13.344,3.0536S23.391,59.1683,26.81,59.1683s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,80.4061,66.87,80.4061s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1492,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,75.7692,66.87,75.7692s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,89.68,40.1815,89.68s9.9248-3.0535,13.3441-3.0535S63.45,89.68,66.87,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,81.99,26.8374,81.99s9.9248,3.0535,13.3441,3.0535S50.1063,81.99,53.5256,81.99,63.45,85.043,66.87,85.043,76.3484,81.99,80.2138,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,103.9,40.1815,103.9s9.9248-3.0535,13.3441-3.0535S63.45,103.9,66.87,103.9s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,94.3187,66.87,94.3187s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.796,7.959l.7053,1.4291a.3852.3852,0,0,0,.29.2108l1.5772.2292a.3852.3852,0,0,1,.2135.6571l-1.1412,1.1125a.385.385,0,0,0-.1108.341L15.6,13.51a.3853.3853,0,0,1-.559.4062L13.63,13.174a.3854.3854,0,0,0-.3586,0l-1.4106.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341l-1.1413-1.1125a.3852.3852,0,0,1,.2135-.6571L12.11,9.5989a.385.385,0,0,0,.29-.2108L13.105,7.959A.3853.3853,0,0,1,13.796,7.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,95.9325a35.8014,35.8014,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.1251,95.7836l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572L68.77,99.4223a.3854.3854,0,0,0-.1108.341l.2694,1.5709a.3852.3852,0,0,1-.559.4061l-1.4107-.7416a.3852.3852,0,0,0-.3585,0L65.19,101.74a.3853.3853,0,0,1-.559-.4061L64.9,99.7633a.3854.3854,0,0,0-.1108-.341L63.648,98.31a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,67.1251,95.7836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.0946,35.3744l.643,1.3028a.3515.3515,0,0,0,.2645.1922l1.4378.2089a.3512.3512,0,0,1,.1946.5991l-1.04,1.0141a.3514.3514,0,0,0-.101.3109l.2456,1.432a.3512.3512,0,0,1-.51.37l-1.286-.6761a.3512.3512,0,0,0-.3269,0l-1.286.6761a.3512.3512,0,0,1-.51-.37l.2456-1.432a.3511.3511,0,0,0-.101-.3109l-1.04-1.0141a.3512.3512,0,0,1,.1947-.5991l1.4378-.2089a.3515.3515,0,0,0,.2644-.1922l.643-1.3028A.3512.3512,0,0,1,67.0946,35.3744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.4987,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3509.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2307,1.3455a.33.33,0,0,1-.4788.3478l-1.2082-.6352a.33.33,0,0,0-.3072,0l-1.2082.6352a.33.33,0,0,1-.4788-.3478l.2307-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6042-1.2241A.33.33,0,0,1,40.4987,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.1693-1.4749-26.75-1.4749s9.9248,3.0536,13.3441,3.0536S-3.9272-1.4749-.0618-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-106.8146,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,3.162-80.1264,3.162s9.9248,3.0536,13.3441,3.0536S-56.8575,3.162-53.4382,3.162s9.9248,3.0536,13.3441,3.0536S-30.1693,3.162-26.75,3.162s9.9248,3.0536,13.3441,3.0536S-3.9272,3.162-.0618,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,12.434-26.75,12.434s9.9248,3.0535,13.3441,3.0535S-3.9272,12.434-.0618,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-106.8146,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,8.1079-26.75,8.1079s9.9248,3.0535,13.3441,3.0535S-3.9272,8.1079-.0618,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,29.4-66.7823,29.4s9.9248-3.0535,13.3441-3.0535S-43.5134,29.4-40.0941,29.4s9.9248-3.0535,13.3441-3.0535S-16.8252,29.4-13.4059,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-106.8146,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,35.72-80.1264,35.72s9.9248,3.0536,13.3441,3.0536S-56.8575,35.72-53.4382,35.72s9.9248,3.0536,13.3441,3.0536S-30.1693,35.72-26.75,35.72s9.9248,3.0536,13.3441,3.0536S-3.9272,35.72-.0618,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-8.6995,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-106.8146,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-106.8146,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M-88.4384,55.8681c3.3379-.8912,5.8475-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,54.168-.0891,54.168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M-106.8749,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.23,49.5311-26.81,49.5311s9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-34.9521,69.9205c3.4655-.8393,5.585-1.8417,8.2021-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-34.9521,23.4241c3.4655-.8394,5.585-1.8418,8.2021-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-106.8146,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-106.8418,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,59.1683-.089,59.1683"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-106.8146,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-106.8146,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,89.68-66.7823,89.68s9.9248-3.0535,13.3441-3.0535S-43.5134,89.68-40.0941,89.68s9.9248-3.0535,13.3441-3.0535S-16.8252,89.68-13.4059,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-106.8146,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,81.99-80.1264,81.99s9.9248,3.0535,13.3441,3.0535S-56.8575,81.99-53.4382,81.99s9.9248,3.0535,13.3441,3.0535S-30.1693,81.99-26.75,81.99s9.9248,3.0535,13.3441,3.0535S-3.9272,81.99-.0618,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,95.9-80.1264,95.9s9.9248,3.0535,13.3441,3.0535S-56.8575,95.9-53.4382,95.9s9.9248,3.0535,13.3441,3.0535S-30.1693,95.9-26.75,95.9s9.9248,3.0535,13.3441,3.0535S-3.9272,95.9-.0618,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-61.93,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-16.6785,103.9-13.2592,103.9-3.78,100.846.0849,100.846"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342-1.5787,186.6-1.5787"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,1.4748,66.87,1.4748s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693-1.5787-26.75-1.5787s9.9248,3.0535,13.3441,3.0535S-3.9272-1.5787-.0618-1.5787"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-422.2673 458.5708) rotate(-180)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,110.382c-2.6972,0-6.1474-1.1259-10.1416-2.43-4.9238-1.607-10.5048-3.4283-15.7939-3.4283-3.9238,0-7.6953,1.295-11.6865,2.6656-4.57,1.57-9.2959,3.1928-14.9131,3.1928-5.7617,0-11.5664-1.5844-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1739-3.3916,1.38-6.5948,2.6845-9.9922,2.6845v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5361,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7916,5.5244,1.5078,11.2373,3.0668,16.8115,3.0668,5.3828,0,9.9961-1.5839,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,51.7758c-5.6855,0-9.289-1.5059-12.7734-2.9629-2.9932-1.2505-5.8193-2.4322-9.6963-2.4322-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2105-9.18,2.2559-12.5508,2.2559-6.95,0-12.62-1.524-18.1035-2.9976-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3277,23.3277,0,0,0-10.8467,2.7525A22.1285,22.1285,0,0,1,.0005,51.7758v-.8c4.26,0,6.957-1.2476,9.8125-2.5689a24.0067,24.0067,0,0,1,11.1826-2.8262c4.5557,0,8.9375,1.1778,13.5762,2.4244,5.4326,1.46,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0347,12.3594-2.2329,6.03-1.4825,12.8652-3.1622,19.456-3.1622,4.0371,0,6.9356,1.2115,10.0049,2.4942a29.2756,29.2756,0,0,0,12.4648,2.9009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,47.1224c-7.0909,0-12.6709-1.8969-17.5928-3.57-3.8291-1.3012-7.1358-2.4253-10.4131-2.4253a30.3524,30.3524,0,0,0-12.3164,2.41A32.461,32.461,0,0,1,.0005,46.0678v-1.4A30.8783,30.8783,0,0,0,12.562,42.2255a31.9175,31.9175,0,0,1,12.8086-2.4991c3.5088,0,6.917,1.1587,10.8633,2.5005,4.82,1.6382,10.2832,3.4952,17.1426,3.4952,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.9366,14.4512-2.9366a26.1151,26.1151,0,0,1,12.1572,2.5352,24.4406,24.4406,0,0,0,11.5039,2.4058v1.4A25.9187,25.9187,0,0,1,94.69,43.5453a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,45.536,58.82,47.1224,53.3765,47.1224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,41.6224c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2872-11.59,2.65-4.5928,1.5772-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.1269C31.811,37.0907,26.9507,35.764,22.5454,35.764c-4.6973,0-8.6338,1.6021-12.44,3.1519C6.686,40.308,3.4565,41.6224.0005,41.6224v-2c3.0644,0,6.1182-1.2431,9.3506-2.559,3.8-1.5464,8.1054-3.2994,13.1943-3.2994,4.6729,0,9.6592,1.3609,14.94,2.8018,5.5048,1.5029,11.1982,3.0566,16.7324,3.0566,5.333,0,9.9219-1.5761,14.36-3.1,4.13-1.4184,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8663,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,3.6293c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4078,86.106-2.2291,80.8169-2.2291c-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738C6.6011,2.3251,3.3979,3.6293.0005,3.6293v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2289,54.2173,2.2289c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,110.3822c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5362,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,36.5248c-7.2071,0-12.8448-1.9165-17.8184-3.6069-3.7705-1.2818-7.0264-2.3887-10.1875-2.3887A29.7583,29.7583,0,0,0,13.3,32.8944,33.0563,33.0563,0,0,1,.0005,35.47v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.517,32.517,0,0,1,13.0547-2.5434c3.624,0,7.25,1.2324,11.0889,2.5371,4.7685,1.6211,10.1728,3.4585,16.917,3.4585,5.13,0,10.1777-1.54,15.06-3.0293,4.7813-1.4585,9.7256-2.9663,14.6553-2.9663a26.7176,26.7176,0,0,1,12.4365,2.5928A23.8433,23.8433,0,0,0,106.7524,32.67v2.8a26.5216,26.5216,0,0,1-12.3418-2.58,24.0342,24.0342,0,0,0-11.3193-2.3608c-4.5127,0-9.042,1.3818-13.8379,2.8447C64.1753,34.9232,58.9243,36.5248,53.3765,36.5248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,31.4144A31.455,31.455,0,0,1,93.4771,28.351c-2.9932-1.251-5.5782-2.3316-9.1944-2.3316-5.7236,0-10.86,1.3648-15.8271,2.6846-5.0147,1.3325-10.1993,2.71-15.9883,2.71-7.16,0-12.2949-1.6279-16.8252-3.0634-3.9463-1.2515-7.3555-2.3316-11.5957-2.3316-4.6817,0-8.2393,1.3042-12.0068,2.6856C8.4067,30.037,4.65,31.4144.0005,31.4144v-3.4c4.0459,0,7.36-1.2148,10.8691-2.5014,3.88-1.4224,7.8916-2.8936,13.1768-2.8936,4.7666,0,8.583,1.21,12.623,2.4908,4.5049,1.4277,9.1641,2.9042,15.7979,2.9042,5.3447,0,10.0908-1.2607,15.1152-2.5957,5.1778-1.3764,10.5332-2.7993,16.7-2.7993,4.2979,0,7.4541,1.3194,10.5059,2.5948a28.19,28.19,0,0,0,11.9638,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,26.4193c-7.3223,0-13.0186-1.9365-18.044-3.6445-3.7109-1.2617-6.916-2.3511-9.9619-2.3511a26.3116,26.3116,0,0,0-11.7471,2.5894,30.6946,30.6946,0,0,1-13.623,2.955v-4.2a26.7887,26.7887,0,0,0,11.9922-2.6255,30.2108,30.2108,0,0,1,13.3779-2.919c3.74,0,7.419,1.25,11.3135,2.5747,4.7178,1.6035,10.0644,3.4209,16.6924,3.4209,5.0078,0,9.6894-1.5107,14.2158-2.9721,4.5576-1.4712,9.27-2.9922,14.3213-2.9922a28.7342,28.7342,0,0,1,13.3135,2.9414,24.6564,24.6564,0,0,0,11.5253,2.5718v4.2a28.54,28.54,0,0,1-13.2158-2.9272,24.8487,24.8487,0,0,0-11.623-2.5859c-4.3907,0-8.5879,1.3545-13.0313,2.789C64.0464,24.8051,59.0454,26.4193,53.3765,26.4193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,20.6639c-4.0136,0-7.7441-1.3569-11.6933-2.7929-4.1084-1.4937-8.3565-3.0381-13.1182-3.0381-3.7754,0-7.7285,1.2676-11.914,2.61-4.9375,1.5835-10.044,3.2211-15.81,3.2211-5.9111,0-11.4209-1.6064-16.75-3.16-4.7617-1.3882-9.2588-2.6987-13.5557-2.6987-4.5869,0-8.8515,1.5854-12.9765,3.1186-3.7891,1.4087-7.3682,2.74-10.9346,2.74v-3.4c2.9551,0,6.2558-1.2271,9.75-2.5264,4.2012-1.5615,8.9629-3.332,14.1611-3.332,4.7822,0,9.5059,1.3769,14.5069,2.8349,5.1,1.4863,10.374,3.0235,15.7988,3.0235,5.2344,0,10.082-1.5547,14.7715-3.0586,4.4453-1.4258,8.6455-2.7725,12.9521-2.7725,5.3613,0,10.1,1.7231,14.2793,3.2432,3.66,1.331,7.1172,2.5879,10.5322,2.5879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,15.25A31.19,31.19,0,0,1,93.5933,12.21C90.57,10.9462,87.96,9.8549,84.2827,9.8549c-6.3887,0-12.8379,1.4257-18.5273,2.684-4.7774,1.0562-8.9033,1.9683-12.3789,1.9683-7.11,0-12.7862-1.7627-17.793-3.3179C31.3335,9.869,27.32,8.6224,23.03,8.6224c-4.6621,0-7.9629,1.5967-11.4561,3.2872C8.1792,13.5521,4.6685,15.25.0005,15.25v-2.8c4.0264,0,7.1-1.4868,10.3535-3.0611C13.978,7.6356,17.7251,5.8226,23.03,5.8226c4.7148,0,8.9258,1.3077,13.3838,2.6924,5.0527,1.5694,10.2773,3.1924,16.9629,3.1924,3.17,0,7.1572-.8818,11.7744-1.9028,5.8291-1.2886,12.4365-2.75,19.1318-2.75,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,8.9657c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,5.3607,32.7078,32.7078,0,0,1,.0005,7.911v-2a30.6257,30.6257,0,0,0,12.456-2.4228A32.1767,32.1767,0,0,1,25.3706.97c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464C73.3062,2.47,78.2212.97,83.0913.97A26.3611,26.3611,0,0,1,95.3677,3.53,24.1944,24.1944,0,0,0,106.7524,5.911v2A26.1847,26.1847,0,0,1,94.57,5.3641,24.3648,24.3648,0,0,0,83.0913,2.97c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,7.3729,58.8638,8.9657,53.3765,8.9657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,105.1483c-5.6855,0-9.289-1.5063-12.7734-2.9629-2.9932-1.2509-5.8193-2.4326-9.6963-2.4326-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2109-9.18,2.2563-12.5508,2.2563-6.95,0-12.62-1.5239-18.1035-2.998-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3214,23.3214,0,0,0-10.8467,2.7529A22.1273,22.1273,0,0,1,.0005,105.1483v-.8c4.26,0,6.957-1.248,9.8125-2.5688A23.9991,23.9991,0,0,1,20.9956,98.953c4.5557,0,8.9375,1.1777,13.5762,2.4248,5.4326,1.4605,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0351,12.3594-2.2334,6.03-1.4819,12.8652-3.1621,19.456-3.1621,4.0371,0,6.9356,1.2114,10.0049,2.4942,3.4111,1.4262,6.9395,2.9013,12.4648,2.9013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,101.4945c-7.0909,0-12.6709-1.8965-17.5928-3.57-3.8291-1.3018-7.1358-2.4253-10.4131-2.4253a30.3507,30.3507,0,0,0-12.3164,2.41A32.4612,32.4612,0,0,1,.0005,100.44v-1.4A30.8766,30.8766,0,0,0,12.562,96.598a31.9178,31.9178,0,0,1,12.8086-2.499c3.5088,0,6.917,1.1587,10.8633,2.5,4.82,1.6382,10.2832,3.4951,17.1426,3.4951,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.936,14.4512-2.936a26.1151,26.1151,0,0,1,12.1572,2.5352A24.4409,24.4409,0,0,0,106.7524,99.04v1.4A25.919,25.919,0,0,1,94.69,97.9179a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,99.9081,58.82,101.4945,53.3765,101.4945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,96.9711c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2871-11.59,2.65-4.5928,1.5771-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.127-5.1465-1.4048-10.0068-2.7314-14.4121-2.7314-4.6973,0-8.6338,1.602-12.44,3.1518C6.686,95.6566,3.4565,96.9711.0005,96.9711v-2c3.0644,0,6.1182-1.2432,9.3506-2.5591,3.8-1.5464,8.1054-3.2993,13.1943-3.2993,4.6729,0,9.6592,1.3608,14.94,2.8017,5.5048,1.503,11.1982,3.0567,16.7324,3.0567,5.333,0,9.9219-1.5762,14.36-3.1,4.13-1.4185,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8662,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,58.1249c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,92.8969c-7.2071,0-12.8448-1.9161-17.8184-3.607-3.7705-1.2812-7.0264-2.3882-10.1875-2.3882A29.7581,29.7581,0,0,0,13.3,89.267a33.0563,33.0563,0,0,1-13.3,2.5757v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.5168,32.5168,0,0,1,13.0547-2.5435c3.624,0,7.25,1.2325,11.0889,2.5371,4.7685,1.6207,10.1728,3.4581,16.917,3.4581,5.13,0,10.1777-1.54,15.06-3.0289,4.7813-1.4584,9.7256-2.9663,14.6553-2.9663a26.7189,26.7189,0,0,1,12.4365,2.5928,23.8431,23.8431,0,0,0,11.2246,2.3482v2.8a26.5228,26.5228,0,0,1-12.3418-2.58,24.0328,24.0328,0,0,0-11.3193-2.3609c-4.5127,0-9.042,1.3819-13.8379,2.8448C64.1753,91.2953,58.9243,92.8969,53.3765,92.8969Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,87.787c-4.7949,0-8.5332-1.4565-12.1474-2.8652-3.34-1.3013-6.4942-2.53-10.3223-2.53-6.3359,0-13.04,1.6474-18.9551,3.1016-5.0068,1.2309-9.332,2.2939-12.86,2.2939-7.1777,0-12.4248-1.7778-17.0537-3.3462-4.0244-1.3633-7.5-2.54-11.7227-2.54-4.6484,0-8.1045,1.4165-11.7637,2.9165-3.5615,1.46-7.2441,2.97-11.9267,2.97v-3.4c4.0127,0,7.2305-1.3188,10.6377-2.7158C14.4409,80.1122,18.3726,78.5,23.6909,78.5c4.7832,0,8.6836,1.3218,12.8135,2.7207,4.5947,1.5566,9.3457,3.166,15.9629,3.166,3.1172,0,7.456-1.0664,12.0488-2.1953,6.1026-1.5,13.0186-3.2,19.7666-3.2,4.4668,0,8.0713,1.4043,11.5567,2.7627,3.4746,1.354,6.7568,2.6328,10.913,2.6328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,82.3c-7.3223,0-13.0186-1.9365-18.044-3.6446-3.7109-1.2617-6.916-2.351-9.9619-2.351a29.1644,29.1644,0,0,0-11.8242,2.32A33.6509,33.6509,0,0,1,.0005,81.2455v-4.2A29.6983,29.6983,0,0,0,12.07,74.6928a33.1145,33.1145,0,0,1,13.3008-2.5884c3.74,0,7.419,1.2505,11.3135,2.5747C41.4019,76.2826,46.7485,78.1,53.3765,78.1c5.0254,0,10.0224-1.5244,14.8554-2.9986,4.83-1.4731,9.8252-2.997,14.8594-2.997a27.3005,27.3005,0,0,1,12.7149,2.6513,23.2632,23.2632,0,0,0,10.9462,2.29v4.2a27.1274,27.1274,0,0,1-12.6211-2.6382,23.4334,23.4334,0,0,0-11.04-2.3027c-4.4082,0-8.89,1.3667-13.6338,2.8144C64.33,80.683,59.0278,82.3,53.3765,82.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,75.9047c-2.8564,0-6.3759-1.149-10.4521-2.48-4.8525-1.584-10.3535-3.3789-15.4834-3.3789-3.7578,0-7.4512,1.2685-11.3623,2.6113-4.6475,1.5962-9.4531,3.2471-15.2373,3.2471-5.8955,0-11.7666-1.6026-17.4434-3.1519-5.1006-1.3921-9.917-2.7065-14.2285-2.7065-4.5605,0-8.4316,1.5757-12.1758,3.1C6.8853,74.5648,3.5933,75.9047.0005,75.9047v-3.4c2.9277,0,5.9189-1.2178,9.0869-2.5073,3.8584-1.57,8.2324-3.3511,13.458-3.3511,4.7666,0,9.7979,1.373,15.1231,2.8266,5.4619,1.4908,11.1084,3.0318,16.5488,3.0318,5.2158,0,9.749-1.5567,14.1328-3.062,4.1875-1.438,8.1416-2.7964,12.4668-2.7964,5.6709,0,11.4443,1.8847,16.5381,3.5473,3.6416,1.1885,7.082,2.3111,9.3974,2.3111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,69.746a31.1913,31.1913,0,0,1-13.1591-3.04c-3.0235-1.2637-5.6338-2.355-9.3106-2.355-6.3721,0-13.0947,1.6523-19.0264,3.11-4.9882,1.2261-9.2968,2.2852-12.789,2.2852-7.082,0-13.0752-1.6109-18.3633-3.0322-4.52-1.2154-8.79-2.3633-13.1084-2.3633a22.2012,22.2012,0,0,0-10.4268,2.6606A22.9661,22.9661,0,0,1,.0005,69.746v-2.8c4.0391,0,6.64-1.2031,9.3926-2.4766a24.8391,24.8391,0,0,1,11.6025-2.9189c4.6875,0,9.1309,1.1943,13.8359,2.459,5.37,1.4438,10.9229,2.9365,17.6358,2.9365,3.1533,0,7.5088-1.0708,12.1211-2.2041,6.0849-1.4961,12.9824-3.1914,19.6943-3.1914,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.3765,63.4613c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,59.8563a32.7078,32.7078,0,0,1-13.1592,2.55v-2a30.6257,30.6257,0,0,0,12.456-2.4228,32.1767,32.1767,0,0,1,12.9141-2.5181c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464,4.753-1.45,9.668-2.9492,14.5381-2.9492a26.3611,26.3611,0,0,1,12.2764,2.56,24.1944,24.1944,0,0,0,11.3847,2.3808v2A26.1862,26.1862,0,0,1,94.57,59.86a24.3633,24.3633,0,0,0-11.4785-2.3941c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,61.8685,58.8638,63.4613,53.3765,63.4613Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7524,3.63c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4077,86.106-2.2289,80.8169-2.2289,76.8931-2.2289,73.1216-.934,69.13.4366,64.56,2.0064,59.8345,3.63,54.2173,3.63,48.4556,3.63,42.6509,2.045,37.0366.5128c-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6132-12.5527,3.1738C6.6011,2.3253,3.3979,3.63.0005,3.63v-1.4c3.123,0,6.2031-1.2535,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2291,54.2173,2.2291c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 63.7886,
    cy: 63.9294,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 63.7886,
    cy: 63.9294,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "x",
    cx: 63.7886,
    cy: 63.9294,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 63.7886,
    cy: 63.9294,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 63.7795,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 63.7795,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 63.7795,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ad",
    cx: 63.7795,
    cy: 63.7257,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "af",
    cx: 63.8743,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ag",
    cx: 63.8743,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ah",
    cx: 63.8743,
    cy: 63.7257,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ai",
    cx: 63.8743,
    cy: 63.7257,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 63.5817,
    y1: 0.067,
    x2: 63.5817,
    y2: 64.6429
  }), /*#__PURE__*/React.createElement("line", {
    className: "ak",
    x1: 63.5817,
    y1: 64.4349,
    x2: 8.8858,
    y2: 96.0137
  }), /*#__PURE__*/React.createElement("line", {
    className: "al",
    x1: 63.5817,
    y1: 64.261,
    x2: 118.5789,
    y2: 96.0137
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceRjr);
export default __webpack_public_path__ + "static/media/space-RJR.1c3a0f61aca57c3e1b818f869bf734c3.svg";
export { ForwardRef as ReactComponent };